import React from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentHeader from './CustomPageDetailContentHeader';
import CustomPageDetailContentEcLargeLayoutItem from './CustomPageDetailContentEcLargeLayoutItem';
import CustomPageDetailContentEcModalItem from './CustomPageDetailContentEcModalItem';

export default class CustomPageDetailContentEcLargeLayout extends React.Component {

  static propTypes = {
    pageBlock: PropTypes.any.isRequired
  };

  render() {
    console.log('Rendering ec-item-large');

    let pageBlock = this.props.pageBlock;
    let ecItems = pageBlock.pageBlockItems.map(function(pageBlockItem, i){
      return <CustomPageDetailContentEcLargeLayoutItem pageBlockItem={pageBlockItem} key={i} />;
    });
    let ecItemModals = pageBlock.pageBlockItems.map(function(pageBlockItem, i){
      return <CustomPageDetailContentEcModalItem pageBlockItem={pageBlockItem} key={i} />;
    });


    return (
      <React.Fragment>
        <div className="m_bdBox" id={"page_block_" + pageBlock.pageBlockId}>
          <CustomPageDetailContentHeader pageBlock={pageBlock}/>
          <ul className="m_floatList s_catalog">
            {ecItems}
          </ul>
        </div>
        {ecItemModals}
      </React.Fragment>
    );
  }
}